// session
export const SESSION_SET_CODE = "SESSION_SET_CODE";
export const SESSION_CLEAR = "SESSION_CLEAR";
export const SESSION_ERROR = "SESSION_ERROR";
export const SESSION_LOAD_SUCCESS = "SESSION_LOAD_SUCCESS";
export const SESSION_LOAD_FAIL = "SESSION_LOAD_FAIL";
export const SESSION_SET_SONG = "SESSION_SET_SONG";
export const SESSION_SET_VERSE = "SESSION_SET_VERSE";
export const SESSION_SET_FOLLOW = "SESSION_SET_FOLLOW";
export const SESSION_JOINING = "SESSION_JOINING";
export const SESSION_JOINED = "SESSION_JOINED";
export const SESSION_JOIN_FAILED = "SESSION_JOIN_FAILED";
export const SESSION_ENDED = "SESSION_ENDED";
export const SESSION_REACTIONS = "SESSION_REACTIONS"; // the hearts count (pushed, or from a tap)
export const SESSION_LISTENERS = "SESSION_LISTENERS"; // people connected to the session
export const SESSION_PEEK = "SESSION_PEEK"; // a guest looks at another section than the live one

// the summary the server answers with when a session ends (shown on the ended page)
export const SUMMARY_SET = "SUMMARY_SET";
export const SUMMARY_CLEAR = "SUMMARY_CLEAR";

// real-time connection and network
export const SOCKET_STATE_CHANGED = "SOCKET_STATE_CHANGED";
export const ONLINE_CHANGED = "ONLINE_CHANGED";

// queue (the songs of the current session)
export const QUEUE_LOAD_SUCCESS = "QUEUE_LOAD_SUCCESS";
export const QUEUE_SONG_ADDED = "QUEUE_SONG_ADDED";
export const QUEUE_SONG_REMOVED = "QUEUE_SONG_REMOVED";
export const QUEUE_CLEARED = "QUEUE_CLEARED";
export const QUEUE_REORDERED = "QUEUE_REORDERED";
export const QUEUE_SONG_SUNG = "QUEUE_SONG_SUNG";
export const QUEUE_SONG_TRANSPOSE = "QUEUE_SONG_TRANSPOSE"; // the host's key for a queued song

// guests' song requests (kept for the host)
export const REQUESTS_LOAD_SUCCESS = "REQUESTS_LOAD_SUCCESS";
export const REQUEST_ADDED = "REQUEST_ADDED";
export const REQUEST_REMOVED = "REQUEST_REMOVED";
export const REQUEST_ASKED = "REQUEST_ASKED"; // this device asked (or voted) for a song, kept per session

// the host's named sets
export const SETS_LOAD_SUCCESS = "SETS_LOAD_SUCCESS";
export const SETS_LOAD_FAILED = "SETS_LOAD_FAILED";
export const SET_SAVED = "SET_SAVED"; // created or changed
export const SET_REMOVED = "SET_REMOVED";
export const SETS_LAST_USED = "SETS_LAST_USED"; // the set the bookmark button adds to
export const SETS_CLEAR = "SETS_CLEAR";

// favourites (the host's library)
export const LIBRARY_SEARCH_CHANGE = "LIBRARY_SEARCH_CHANGE";
export const LIBRARY_LOAD_SUCCESS = "LIBRARY_LOAD_SUCCESS";
export const LIBRARY_LOAD_FAILED = "LIBRARY_LOAD_FAILED";
export const LIBRARY_SONG_ADDED = "LIBRARY_SONG_ADDED";
export const LIBRARY_SONG_REMOVED = "LIBRARY_SONG_REMOVED";

// catalog ("Songs")
export const CATALOG_SEARCH_CHANGE = "CATALOG_SEARCH_CHANGE";
export const CATALOG_SEARCH_RESULTS = "CATALOG_SEARCH_RESULTS";
export const CATALOG_SEARCH_FAILED = "CATALOG_SEARCH_FAILED";
export const CATALOG_TOP_SONGS = "CATALOG_TOP_SONGS";
export const CATALOG_SONG_LOADED = "CATALOG_SONG_LOADED";
export const CATALOG_SET_FILTER = "CATALOG_SET_FILTER";
export const CATALOG_SUNG_BEFORE = "CATALOG_SUNG_BEFORE";

// a song in the catalog changed or was deleted (affects queue, library and catalog lists)
export const SONG_UPDATED = "SONG_UPDATED";
export const SONG_DELETED = "SONG_DELETED";

// per-device display preferences
export const PREFERENCES_SET = "PREFERENCES_SET";
export const PREFERENCES_SET_SONG_KEY = "PREFERENCES_SET_SONG_KEY";

// transient user notices (toasts)
export const NOTICE_SHOW = "NOTICE_SHOW";
export const NOTICE_CLEAR = "NOTICE_CLEAR";

// this device's host identity
export const HOST_SET = "HOST_SET";

// host changes made while offline
export const SESSION_PENDING_SELECTION = "SESSION_PENDING_SELECTION";
export const SESSION_PENDING_SENT = "SESSION_PENDING_SENT";

// sound sync (near-ultrasonic host -> participants)
export const SOUND_SYNC_SET = "SOUND_SYNC_SET";
